/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React from 'react';

const Activity = (props) => {
    return(
        <div className="resultsIn">
            <div className="resultsInTitle">
                <i className="ibon-cellphone charcoal"></i>
                <strong>Actividad mensual en soluciones</strong>
            </div>
            <div className="resultInItem">
                <span className="neutral">Datos personales</span>
                <br/>
                <strong>40 - 10%</strong>
            </div>
            <div className="resultInItem">
            <span className="neutral">Tarjetas </span>
                <br/>
                <strong>10%</strong>
            </div>
            <div className="resultInItem">
                <span className="neutral">Movimientos</span>
                <br/>
                <strong>10%</strong>
            </div>
            <div className="resultInItem">
                <span className="neutral">Edos. de cuenta</span>
                <br/>
                <strong>10%</strong>
            </div>
            <div className="resultInItem">
                <span className="neutral">Bloqueos</span>
                <br/>
                <strong>10%</strong>
            </div>
            <div className="resultInItem">
                <span className="neutral">Cancelación</span>
                <br/>
                <strong>10%</strong>
            </div>
            <div className="resultInItem">
                <span className="neutral">Cupones</span>
                <br/>
                <strong>10%</strong>
            </div>
        </div>
    )
}

export default Activity;

